<template>
    <div class="relative-position" :class="$q.platform.is.mobile ? 'q-ma-sm' : 'q-ma-lg'">
        <q-table
            :data="orders"
            :columns="columns"
            row-key="name"
            :filter="filter"
            :hide-bottom="orders.length > 0 ? true : false"
            flat
            class="cursor-pointer"
            @row-click="showOrderHistory"
            :grid="$q.platform.is.mobile"
            :pagination.sync="pagination"
            >

            <template v-slot:top-right v-if="!$q.platform.is.mobile">
                <q-input dense debounce="300" v-model="filter" :placeholder="$t('search')">
                    <template v-slot:append>
                        <q-icon name="fal fa-search" />
                    </template>
                </q-input>
            </template>

            <template v-slot:header="props">
                <q-tr :props="props">
                    <q-th v-for="col in props.cols" :key="col.name" :props="props">
                        {{ $t(col.label) }}
                    </q-th>
                </q-tr>
            </template>

            <template v-slot:body-cell-reward_image="props">
                <q-td :props="props" auto-width>
                    <q-img :src="props.value"  style="height: auto; width: 150px;" />
                </q-td>
            </template>

            <template v-slot:body-cell-status="props">
                <q-td :props="props" auto-width>
                    <q-chip square dense :icon="getStatus(props.value).icon" :color="getStatus(props.value).color" text-color="white" class="full-width">
                        {{ $t(getStatus(props.value).label) }}
                    </q-chip>
                </q-td>
            </template>

            <template v-slot:body-cell-created_date="props">
                <q-td :props="props">
                    {{ $dateUtil.fDateTime(props.value) }}
                </q-td>
            </template>

            <template v-slot:item="props" v-if="$q.platform.is.mobile">
                <div class="col-xs-12 q-mb-lg">
                    <q-card @click="showOrderHistoryMobile(props.row)" class="bg-grey-3">
                        <img :src="props.row.reward_image" />

                        <q-card-section class="q-px-md">
                            <div class="row">
                                <div class="col-12 text-subtitle2 title text-weight-bold">
                                    {{ props.row.title }}
                                </div>
                            </div>

                            <div class="row q-mt-md">
                                <div class="col-12 text-grey-8" v-for="col in props.cols.filter(col => col.name !== 'reward_image' && col.name !== 'title' && col.name !== 'status')" :key="col.name">
                                    {{ $t(col.label) }}:

                                    <template v-if="col.name === 'created_date'">
                                        {{ $dateUtil.fDateTime(col.value) }}
                                    </template>

                                    <template v-else>
                                        {{ col.value }}
                                    </template>
                                </div>
                            </div>

                            <div class="row q-mt-md">
                                <div class="col-12" v-for="col in props.cols.filter(col => col.name === 'status')" :key="col.name">
                                    <q-chip square :icon="getStatus(col.value).icon" :color="getStatus(col.value).color" text-color="white" class="full-width">
                                        {{ $t(getStatus(col.value).label) }}
                                    </q-chip>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </template>
        </q-table>

        <q-dialog :maximized="$q.platform.is.mobile" v-model="show_order_history">
            <q-card :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; max-height: 80vh;'">
                <q-toolbar>
                    <q-toolbar-title>{{ $t('order_history') }}</q-toolbar-title>

                    <q-btn flat round dense icon="fal fa-times" v-close-popup />
                </q-toolbar>

                <q-separator />

                <q-card-section class="q-py-xl">
                    <q-timeline layout="comfortable" color="secondary">
                        <q-timeline-entry heading>
                            {{ order.title }}
                        </q-timeline-entry>

                        <q-timeline-entry  v-for="c in order.history" :key="c.id"
                            :title="$t(getStatus(c.status).label)"
                            :icon="getStatus(c.status).icon"
                            :color="getStatus(c.status).color"
                            :subtitle="$dateUtil.fDateTime(c.created_date)"
                            side="left"
                            >
                            <div>
                                {{ c.observation }}
                            </div>
                        </q-timeline-entry>
                    </q-timeline>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-inner-loading :showing="loading">
            <q-spinner-facebook size="1rem" color="text-blue-grey-4" />
        </q-inner-loading>
    </div>
</template>

<script>
export default {
    name: 'UserOrders',

    data() {
        return {
            columns: [
                { name: 'reward_image', align: 'left', label: '', field: 'reward_image', sortable: false },
                { name: 'title', align: 'left', label: '', field: 'title', sortable: true },
                { name: 'order_number', align: 'left', label: 'order', field: 'order_number', sortable: true },
                { name: 'status', align: 'left', label: 'status', field: 'status', sortable: true },
                { name: 'price', align: 'left', label: 'points', field: 'price', sortable: true },
                { name: 'created_date', align: 'left', label: 'date', field: 'created_date', sortable: true }
            ],
            filter: '',
            loading: false,
            order: {},
            orders: [],
            pagination: {
                sortBy: 'desc',
                descending: false,
                page: 1,
                rowsPerPage: 0
            },
            show_order_history: false
        }
    },

    methods: {
        getUserOrders() {
            this.loading = true

            this.$axios.get(`/etraining_profile/my_profile/reward_orders/`)
            .then(response => {
                this.orders = response.data.map(e => ({ ...e, reward_image: e.reward_images[0] }) )
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        getStatus(status) {
            switch(status) {
                case 1: return { color: 'amber', icon: 'fal fa-hourglass-half', label: 'awaiting_approval' }
                break
                case 2: return { color: 'positive', icon: 'fal fa-check-double', label: 'approved' }
                break
                case 3: return { color: 'negative', icon: 'fal fa-times', label: 'reproved' }
                break
                case 4: return { color: 'orange', icon: 'fal fa-shipping-fast', label: 'shipped' }
                break
                case 5: return { color: 'light-green', icon: 'fal fa-hand-holding-box', label: 'delivered' }
                break
                default: return { color: '', icon: '', label: '' }
                break
            }
        },

        showOrderHistory(evt, row) {
            this.order = row
            this.show_order_history = true
        },

        showOrderHistoryMobile(row) {
            this.order = row
            this.show_order_history = true
        }
    },

    created() {
        this.getUserOrders()
    }
}
</script>

<style>

</style>